export default ({
  isFirstLoading: true,
  fetching: {
    getQualifiers: false,
    saveQualifier: false,
  },
  api: {
    qualifiers: [],
  }
});